import * as React from "react";
const HiddenFieldWrapper = ({
  children,
  hiddenFields,
  namePrefix = null,
  ignoreFieldRestrictions,
  ...rest
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
  if (React.isValidElement(child)) {
    if ((hiddenFields == null ? void 0 : hiddenFields.includes(namePrefix ? namePrefix + child.props.name : child.props.name)) && !ignoreFieldRestrictions)
      return null;
    return React.cloneElement(child, rest);
  }
  return child;
}));
export default HiddenFieldWrapper;
